import React from 'react'

import SummaryBlock from "../components/SummaryBlock"

import {
    container,
    title as titleStyle,
    blocksContainer,
} from "./SummaryBlocks.module.css"

export default function SummaryBlocks({ title, sections, type, maxPosts }) {

    // <SummaryBlocks 
    //     sections={[
    //         'api-reference',
    //         'tutorials',
    //         'release'
    //     ]}
    // />

    // <SummaryBlocks 
    //     title={'Popular Tutorials'} 
    //     sections={[
    //         'tutorials/transcoding',
    //         'tutorials/streaming',
    //         'api-reference/player',
    //         'tutorials/account',
    //     ]}
    //     type={'small'}
    //     maxPosts={5}
    // />    

    // const renderSummaryBlock = (section, index) => {
    //     const key = typeof section === 'string' ? section : section.url;
    //     const sectionProps = typeof section === 'string' ? { section } : { section: section.url, sectionTitle: section.title };
    
    //     return <SummaryBlock key={key} {...sectionProps} type={type} maxPosts={maxPosts} />;
    // };

    // const renderSummaryBlock = (section, index) => {
    //     const key = typeof section === 'string' ? section : section.url;
        
    //     let sectionProps;
    //     if (typeof section === 'string') {
    //         sectionProps = { section };
    //     } else {
    //         sectionProps = { 
    //             section: section.url, 
    //             sectionTitle: section.title,
    //             // Use section's maxPosts if available, otherwise fall back to the default maxPosts
    //             maxPosts: section.maxPosts !== undefined ? section.maxPosts : maxPosts
    //         };
    //     }
    
    //     return <SummaryBlock key={key} {...sectionProps} type={type} />;
    // };
    

    return(
        <div className={container}>            
            { title && <div className={titleStyle}>{title}</div>
            }
            <div className={blocksContainer}>
            {/* { sections.map((section, index) => (
                <SummaryBlock key={index} section={section} type={type} maxPosts={maxPosts} />
            ))} */}
            {/* {sections.map((section, index) => (
                typeof section === 'string' ?
                    <SummaryBlock key={index} section={section} type={type} maxPosts={maxPosts} /> :
                    <SummaryBlock 
                        key={index} 
                        section={section.url ? section.url : undefined} 
                        type={type} 
                        maxPosts={section.maxPosts ? section.maxPosts : maxPosts} 
                        sectionTitle={section.title ? section.title : undefined}
                    />
            ))} */}
            {sections.map((section, index) => (
                typeof section === 'string' ? (
                    <SummaryBlock key={index} section={section} type={type} maxPosts={maxPosts} />
                ) : typeof section === 'object' && section !== null && section.url ? (
                    <SummaryBlock 
                        key={index} 
                        section={section.url || undefined} 
                        type={type} 
                        maxPosts={section.maxPosts || maxPosts} 
                        sectionTitle={section.title || undefined}
                    />
                ) : null
            ))}            
            {/* {sections.map(renderSummaryBlock)} */}
            </div>
        </div>
    )
}
